var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOpportunity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#9258E7",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.333 15.7l-5.991-.517L18 9.667l-2.342 5.525-5.992.508 4.55 3.942L12.85 25.5 18 22.392l5.15 3.108-1.358-5.858 4.541-3.942zM18 20.833l-3.133 1.892.833-3.567-2.767-2.4 3.65-.316L18 13.083l1.425 3.367 3.65.317-2.767 2.4.834 3.566-3.142-1.9z",
    fill: "#5D43CF"
  })));
}

export default __webpack_public_path__ + "70181253786e9a6858c73b0ac74f64b6.svg";
export { SvgOpportunity as ReactComponent };